/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateScanBody
 */
export interface ValidateScanBody {
    /**
     * The scanned QR code data (typically a URL)
     * @type {string}
     * @memberof ValidateScanBody
     */
    qrData: string;
    /**
     * The quest config ID
     * @type {string}
     * @memberof ValidateScanBody
     */
    questConfigId: string;
    /**
     * The milestone ID within the quest
     * @type {string}
     * @memberof ValidateScanBody
     */
    milestoneId: string;
}

/**
 * Check if a given object implements the ValidateScanBody interface.
 */
export function instanceOfValidateScanBody(value: object): value is ValidateScanBody {
    if (!('qrData' in value) || value['qrData'] === undefined) return false;
    if (!('questConfigId' in value) || value['questConfigId'] === undefined) return false;
    if (!('milestoneId' in value) || value['milestoneId'] === undefined) return false;
    return true;
}

export function ValidateScanBodyFromJSON(json: any): ValidateScanBody {
    return ValidateScanBodyFromJSONTyped(json, false);
}

export function ValidateScanBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateScanBody {
    if (json == null) {
        return json;
    }
    return {
        
        'qrData': json['qrData'],
        'questConfigId': json['questConfigId'],
        'milestoneId': json['milestoneId'],
    };
}

export function ValidateScanBodyToJSON(json: any): ValidateScanBody {
    return ValidateScanBodyToJSONTyped(json, false);
}

export function ValidateScanBodyToJSONTyped(value?: ValidateScanBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qrData': value['qrData'],
        'questConfigId': value['questConfigId'],
        'milestoneId': value['milestoneId'],
    };
}

